/**
 * @file 发送点击统计
 * @author dafo<huanghouin@baijiahulian.com>
 * @module module/click
 */
import request from './util/request';
import {
    parse,
    camelToUnder
} from './util/json';
import configurable from './util/configurable';
import {
    on,
    off,
    closest
} from './util/dom';
import {
    trackID,
    getUserID,
    Config
} from './util/config';
import warnForbiddenKeys from './util/forbiddenWords';
import metric from './metric';

/**
 * 屏蔽点击上报的标记属性名
 *
 * @const {string}
 */
const NO_LOG_FLAG = 'data-habo-noclick';

/**
 * 收集点击上报所必需参数的属性名
 *
 * @const {string}
 */
const LOG_FLAG_N_PARAMS = 'data-habo-params';

/**
 * 点击事件上报
 *
 * @function
 * @param {Object} json 要上报的数据
 * @param {Function=} callback 上报后的回调
 */
const report = configurable((json, callback) => {
    const {
        event_id = '',
        logger_id,
        user_id = getUserID(),
        index,
        ...rest
    } = camelToUnder(json);

    // 处理多个 event id 的情况，第一个为点击事件的 id，第二个为滚动事件的 id
    const [eventID] = String(event_id).split(',');

    // 必要的上报数据
    const clickLogData = {
        // 当前页面，与 PV 上报字段名保持一致
        page_url: location.href,

        // 事件 id
        event_id: eventID,

        // 对应的后端日志 id
        logger_id,

        // 登录用户 id
        user_id,

        // 对于列表项中的展示 ，需要该字段区分是第几个列表项，从 0 开始
        index,

        // 用户的唯一标识，由后端生成写到 cookie 中
        track_id: trackID,

        ...rest
    };
    warnForbiddenKeys(clickLogData);
    request(Config.VERB)(`${Config.GS}`, clickLogData, callback);
    // 自动上报点击指标数据到轻舟
    metric({
        ...clickLogData,
        metric: 'click'
    });
}, {});

/**
 * 处理文档的点击事件
 *
 * @param {Event} e 点击事件对象
 * @param {HTMLElement} e.target 点击事件源对象
 */
const observe = ({target}) => {

    // 屏蔽点击上报
    if (
        closest(target, `[${NO_LOG_FLAG}]`)
        || !(target = closest(target, `[${LOG_FLAG_N_PARAMS}]`))
    ) {
        return;
    }

    const params = parse(target.getAttribute(LOG_FLAG_N_PARAMS));

    report(params);
};

const win = typeof window !== 'undefined' && window;
const doc = win && document;

/**
 * 解除相关事件的绑定
 */
const destroy = () => {
    off(win, 'unload', destroy);
    off(doc, 'click', observe);
};

on(doc, 'click', observe);
on(win, 'unload', destroy);

export default report;
